var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w-full h-12 px-4 font-semibold rounded-md focus:outline-none",class:{
    'text-white bg-blue-600 border-2 border-blue-600':
      _vm.buttonType === 'primary',
    'border-2 border-blue-600 dark:text-white': _vm.buttonType === 'outline',
    'border-2 border-red-600 dark:text-white':
      _vm.buttonType === 'outline-danger',
  },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }